import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { compose } from 'recompose';

import { localeDate } from 'Util/datetime';
import { ref } from 'Util/CustomPropTypes';
import { withConfig } from 'Context/ConfigContext';

const getPosition = () => {
  return Math.floor(Math.random() * 90) + 5;
};

const getFontSize = () => {
  const viewportWidth = window.innerWidth;
  if (viewportWidth < 576) {
    return '18px';
  } else if (viewportWidth < 768) {
    return '28px';
  } else {
    return '32px';
  }
};

const visibilityStyle =
  'display: block !important; visibility: visible !important; opacity: 1 !important; z-index: 1 !important; width: fit-content !important; min-width: fit-content; ';

const textStyle = `font-weight: 400!important; font-size: ${getFontSize()} !important; color: white !important; font-family: initial !important; line-height: initial !important; text-shadow: 4px 4px 4px rgba(0, 0, 0, 0.5) !important;`;

const getOverlayStyle = () => {
  const positionX = getPosition();
  const positionY = getPosition();
  const overlayBoxStyle =
    'max-width: 50% !important; position: absolute !important; opacity: 0.5 !important; pointer-events:none;';

  const positionStyle = `left: ${positionX}%; top: ${positionY}%; text-align: ${
    positionX > 50 ? 'right' : 'left'
  }; transform: translate(${positionX > 50 ? '-100%' : '0'}, ${positionY > 60 ? '-100%' : '0'})`;

  const style = `${visibilityStyle} ${overlayBoxStyle} ${positionStyle}`;
  return style;
};

const renderWatermarkAccount = (watermarkType, userProfile = {}) => {
  const { displayName, phoneNumber } = userProfile;

  switch (watermarkType) {
    case 'withPhoneNumber': {
      return `<div style="${visibilityStyle} ${textStyle}">${displayName}</div>
      <div style="${visibilityStyle} ${textStyle}">(${phoneNumber})</div>`;
    }
    case 'onlyDisplayName':
    default: {
      return `<div style="${visibilityStyle} ${textStyle}">${displayName}</div>`;
    }
  }
};

const createOverlayBox = (userProfile, t, watermarkType) => {
  const overlayBox = document.createElement('div');
  const currentDate = new Date();
  const dateTime = localeDate(currentDate, 'th', 'D MMMM YYYY HH:mm');
  const watermarkMessage = renderWatermarkAccount(watermarkType, userProfile);

  overlayBox.setAttribute('style', getOverlayStyle());
  overlayBox.innerHTML = `<div style="${visibilityStyle} ${textStyle}">${t(
    'VIDEO_PLAYER.OVERLAY'
  )}</div>${watermarkMessage}<div style="${visibilityStyle} ${textStyle}">${dateTime}</div>`;
  overlayBox.id = 'overlayBox';
  return overlayBox;
};

class Overlay extends Component {
  state = {
    isShowing: false,
  };

  componentDidMount() {
    this._initComponentTimeout = setTimeout(() => {
      this.toggleComponent(this.state.isShowing);
    }, 0);
  }

  componentWillUnmount() {
    if (this._timeout) {
      clearTimeout(this._timeout);
    }
    if (this._initComponentTimeout) {
      clearTimeout(this._initComponentTimeout);
    }
  }

  setToggleTimeout = (isShowing) => {
    const nextShowInterval = 3 * 60 * 1000 + (Math.random() - 0.5) * 2 * 30 * 1000;
    const nextInterval = isShowing ? 10000 : nextShowInterval;
    this._timeout = setTimeout(this.toggleComponent, nextInterval);
  };

  removeCurrentOverlayElement = () => {
    const currentOverlay = document.querySelector('#overlayBox');
    if (!currentOverlay) {
      this.props.onOverlayCorrupted();
    }
    if (this.props.videoRef.current.player) {
      this.props.videoRef.current.player.el().removeChild(currentOverlay);
    } else {
      this.props.videoRef.current.removeChild(currentOverlay);
    }
  };

  addNewOverlayElement = () => {
    const { displayName, phoneNumber, t, appConfig } = this.props;
    const {
      videoPlayer: { watermarkType },
    } = appConfig;

    const userProfile = { displayName, phoneNumber };
    const overlayBox = createOverlayBox(userProfile, t, watermarkType);
    if (this.props.videoRef.current.player) {
      this.props.videoRef.current.player.el().appendChild(overlayBox);
    } else {
      // for LearnCraftVideoBox
      this.props.videoRef.current.appendChild(overlayBox);
    }
  };

  toggleComponent = () => {
    if (this.state.isShowing) {
      this.removeCurrentOverlayElement();
    } else {
      this.addNewOverlayElement();
    }

    this.setState(
      {
        isShowing: !this.state.isShowing,
      },
      () => this.setToggleTimeout(this.state.isShowing)
    );
  };

  render() {
    return null;
  }
}

const OverlayPropTypes = {
  videoRef: ref,
  displayName: PropTypes.string,
  onOverlayCorrupted: PropTypes.func,
};

Overlay.propTypes = OverlayPropTypes;

Overlay.defaultProps = {
  onOverlayCorrupted: () => {},
};

export { OverlayPropTypes };

export default compose(withConfig, withTranslation('classroom'))(Overlay);
